import { useState, useEffect } from "react";
import { ICON_BASE_PATH } from "@/app/utils/config";

interface CarouselItem {
  title: string;
  description: string;
}

interface AlternativeInfoCarouselProps {
  items: CarouselItem[];
}

const AlternativeInfoCarousel = ({ items }: AlternativeInfoCarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isRtl, setIsRtl] = useState(false);

  // ...............................useEffect..........................................

  useEffect(() => {
    const checkDirection = () => {
      const direction = globalThis.getComputedStyle(
        document.documentElement,
      ).direction;
      setIsRtl(direction === "rtl");
    };

    checkDirection();
    const observer = new MutationObserver(checkDirection);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["dir"],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [items.length]);

  // ...............................nextSlide..........................................

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % items.length);
  const prevSlide = () =>
    setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);

  if (!items || items.length === 0) return null;

  const translateXValue = isRtl
    ? currentIndex * (100 / items.length)
    : -(currentIndex * (100 / items.length));

  return (
    <div className="gx-bal-carousel-wrapper">
      <div className="gx-bal-carousel-container">
        <div className="gx-bal-carousel-content" style={{ overflow: "hidden" }}>
          <div
            className="gx-bal-carousel-track"
            style={{
              display: "flex",
              transition: "transform 0.5s ease-in-out",
              width: `${items.length * 100}%`,
              transform: `translateX(${translateXValue}%)`,
            }}
          >
            {items.map(
              (
                item, 
              ) => (
                <div
                  key={item.title}
                  className="gx-bal-carousel-item"
                  style={{ width: `${100 / items.length}%` }}
                >
                  <div className="gx-bal-info-icon">
                    <img
                      alt="info"
                      width="16"
                      height="16"
                      src={`${ICON_BASE_PATH}info.png`}
                    />
                  </div>
                  <div className="gx-bal-info-content">
                    <h6 className="gx-p14-b">{item.title}</h6>
                    <p className="gx-p14">{item.description}</p>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>

        {items.length > 1 && (
          <div dir="ltr" className="gx-bal-nav-buttons">
            <button
              onClick={isRtl ? nextSlide : prevSlide}
              className="gx-bal-nav-btn"
            >
              <img
                className="gx-bal-nav-icon"
                src={`${ICON_BASE_PATH}leftarrow_withbg.svg`}
                alt="left"
              />
            </button>

            <button
              onClick={isRtl ? prevSlide : nextSlide}
              className="gx-bal-nav-btn"
            >
              <img
                className="gx-bal-nav-icon"
                src={`${ICON_BASE_PATH}rightarrow_withbg.svg`}
                alt="right"
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlternativeInfoCarousel;
